<template>
    <div class="insight_waiilist">
        <a-row style="background-color: #fff;">
            <a-col :md="{ span: 18 }" :xs="{ span: 24 }">
                <a-menu v-model:selectedKeys="current" mode="horizontal" :items="items" />
            </a-col>
            <a-col :md="{ span: 6 }" :xs="{ span: 24 }" style="padding-top: 6px; padding-right: 5px;" v-if="store_options.length > 0">
                <a-select
                    v-model:value="sid"
                    :options="store_options"
                    style="width: 300px"
                    @change="handleChangeStore"
                >
                </a-select>
            </a-col>
        </a-row>
        <a-row style="margin: 10px 0;">
            <a-col :span="24" style="padding-right: 0px; height: 100%;">
                <a-card :title="$t('insight.dashboard')" :bordered="false" style="width: 100%; height: 100%;">
                    <template #extra>
                        <a-button type="primary" @click="do_show_export_layer">{{ $t('waitlist.export_title') }}</a-button>
                    </template>
                    <a-row :gutter="16">
                        <a-col :span="is_mobile ? 12 : 8" v-for="(item, index) in dashboard_cards" v-bind:key="item.text" :style="{marginTop: index > 1 ? '5px': '0px'}">
                            <a-card :bodyStyle="{'padding-left': '10px'}" style="width: 100%;background-color: #eee;">
                                <a-card-meta :title="mapper['dashboard'][item.type].text" :description="mapper['dashboard'][item.type].sub_text == 'diners' ? '(' + item.sub_value + ' diners)' : mapper['dashboard'][item.type].sub_text">
                                    <template #avatar>
                                        <ScheduleOutlined  style="font-size: 28px;" v-if="mapper['dashboard'][item.type].icon == 'schedule' && !is_mobile" />
                                        <TeamOutlined style="font-size: 28px;" v-if="mapper['dashboard'][item.type].icon == 'team' && !is_mobile" />
                                        <StopOutlined style="font-size: 28px;" v-if="mapper['dashboard'][item.type].icon == 'stop' && !is_mobile"/>
                                        <ContactsOutlined style="font-size: 28px;" v-if="mapper['dashboard'][item.type].icon == 'contacts' && !is_mobile" />
                                        <h3 style="display: inline-block;font-size: 33px; margin-left: 5px;">{{ item.value }}</h3>
                                    </template>
                                </a-card-meta>
                            </a-card>
                        </a-col>
                    </a-row>
                </a-card>
            </a-col>
        </a-row>
        <a-row style="margin: 10px 0;">
            <a-col :span="24" style="padding-right: 5px; height: 100%;">
                <a-card :title="$t('insight.number_of_waitlists')" :bordered="false" style="width: 100%; height: 100%;">
                    <template #extra v-if="!is_mobile">
                        <a-range-picker @change="onDateChange('number')" v-model:value="number_date" :format="dateFormat"></a-range-picker>
                        <a-select v-model:value="number_graph_type" style="width: 120px" @change="handleNumberTypeChange('number', $event)">
                            <a-select-option value="daily">
                                {{ $t('insight.daily') }}
                            </a-select-option>
                            <a-select-option value="week">
                                {{ $t('insight.weekly') }}
                            </a-select-option>
                            <a-select-option value="month">
                                {{ $t('insight.monthly') }}
                            </a-select-option>
                            <a-select-option value="year">
                                {{ $t('insight.yearly') }}
                            </a-select-option>
                        </a-select>
                    </template>
                    <div v-if="is_mobile">
                        <a-range-picker @change="onDateChange('number')" v-model:value="number_date" :format="dateFormat"></a-range-picker>
                        <a-select v-model:value="number_graph_type" style="width: 120px" @change="handleNumberTypeChange('number', $event)">
                            <a-select-option value="daily">
                                {{ $t('insight.daily') }}
                            </a-select-option>
                            <a-select-option value="week">
                                {{ $t('insight.weekly') }}
                            </a-select-option>
                            <a-select-option value="month">
                                {{ $t('insight.monthly') }}
                            </a-select-option>
                            <a-select-option value="year">
                                {{ $t('insight.yearly') }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <a-row :gutter="is_mobile ? 2 : 16" style="margin-top: 5px;">
                        <a-col :span="is_mobile ? 0 : 2">
                        </a-col>
                        <a-col :span="is_mobile ? 8 : 5">
                            <div class="insight_select_card" @click="changeSelectCard('number', 'wait_count')" :class="{current: number_select_card == 'wait_count'}">
                                <h3>{{ $t('insight.total_waitlist') }}</h3>
                                <h2>{{ number_dashboard_cards.length > 0 && number_dashboard_cards[1].value || 0 }}</h2>
                                <h3>{{ number_dashboard_cards.length > 0 && number_dashboard_cards[1].sub_value || 0 }} {{ $t('insight.diners') }}</h3>
                            </div>
                        </a-col>
                        <a-col :span="is_mobile ? 8 : 5">
                            <div class="insight_select_card" @click="changeSelectCard('number', 'seated')" :class="{current: number_select_card == 'seated'}">
                                <h3>{{ $t('insight.seated_waitlists') }}</h3>
                                <h2>
                                    <span>{{ number_dashboard_cards.length > 0 && number_dashboard_cards[3].value || 0 }}</span>
                                    <span class="sub_text" v-if="false">
                                        <span>0.00%</span>
                                        <span>Attendance</span>
                                    </span>
                                </h2>
                                <h3>{{ number_dashboard_cards.length > 0 && number_dashboard_cards[3].sub_value || 0 }} {{ $t('insight.diners') }}</h3>
                            </div>
                        </a-col>
                        <a-col :span="is_mobile ? 8 : 5">
                            <div class="insight_select_card" @click="changeSelectCard('number', 'no_show')" :class="{current: number_select_card == 'no_show'}">
                                <h3>{{ $t('insight.no_show') }}</h3>
                                <h2>
                                    <span>{{ number_dashboard_cards.length > 0 && number_dashboard_cards[4].value || 0 }}</span>
                                    <span class="sub_text" v-if="false">
                                        <span>0.00%</span>
                                        <span>&nbsp;</span>
                                    </span>
                                </h2>
                                <h3>{{ number_dashboard_cards.length > 0 && number_dashboard_cards[4].sub_value || 0 }} {{ $t('insight.diners') }}</h3>
                            </div>
                        </a-col>
                    </a-row>
                    <div style="margin-top: 20px; height: 300px;" class="chart" id="number_date_graph_chart"></div>
                    <div style="margin-top: 20px; height: 300px;" v-show="number_graph_type === 'daily'" class="chart" id="number_day_graph_chart"></div>
                </a-card>
            </a-col>
        </a-row>
        <a-row style="margin: 10px 0;">
            <a-col :span="24" style="padding-right: 5px; height: auto;">
                <a-card :title="$t('insight.waitlist_source')" :bordered="false" style="width: 100%; height: 100%;">
                    <template #extra v-if="!is_mobile">
                        <a-range-picker @change="onDateChange('source')" v-model:value="source_date" :format="dateFormat"></a-range-picker>
                        <a-select v-model:value="source_graph_type" style="width: 120px" @change="handleNumberTypeChange('source', $event)">
                            <a-select-option value="daily">
                                {{ $t('insight.daily') }}
                            </a-select-option>
                            <a-select-option value="week">
                                {{ $t('insight.weekly') }}
                            </a-select-option>
                            <a-select-option value="month">
                                {{ $t('insight.monthly') }}
                            </a-select-option>
                            <a-select-option value="year">
                                {{ $t('insight.yearly') }}
                            </a-select-option>
                        </a-select>
                    </template>
                    <div v-if="is_mobile">
                        <a-range-picker @change="onDateChange('source')" v-model:value="source_date" :format="dateFormat"></a-range-picker>
                        <a-select v-model:value="source_graph_type" style="width: 120px" @change="handleNumberTypeChange('source', $event)">
                            <a-select-option value="daily">
                                {{ $t('insight.daily') }}
                            </a-select-option>
                            <a-select-option value="week">
                                {{ $t('insight.weekly') }}
                            </a-select-option>
                            <a-select-option value="month">
                                {{ $t('insight.monthly') }}
                            </a-select-option>
                            <a-select-option value="year">
                                {{ $t('insight.yearly') }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <a-row :gutter="16" style="margin-top: 5px;">
                        <a-col :span="is_mobile ? 0 : 2">
                        </a-col>
                        <a-col :span="is_mobile ? 12 : 4">
                            <div class="insight_select_card" @click="changeSelectCard('source', 'qr')" :class="{current: source_select_card == 'qr'}">
                                <h3>{{ $t('insight.via_qr_code') }}</h3>
                                <h2>
                                    <span>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[0] && source_dashboard_cards[0].value || 0 }}</span>
                                    <span class="sub_text">
                                        <span>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[0] && source_dashboard_cards[0].percent || '0.0' }}%</span>
                                        <span>&nbsp;</span>
                                    </span>
                                </h2>
                                <h3>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[0] && source_dashboard_cards[0].sub_value || 0 }} {{ $t('insight.diners') }}</h3>
                            </div>
                        </a-col>
                        <a-col :span="is_mobile ? 12 : 4">
                            <div class="insight_select_card" @click="changeSelectCard('source', 'admin')" :class="{current: source_select_card == 'admin'}">
                                <h3>{{ $t('insight.via_tablet') }}</h3>
                                <h2>
                                    <span>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[1] && source_dashboard_cards[1].value || 0 }}</span>
                                    <span class="sub_text">
                                        <span>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[1] && source_dashboard_cards[1].percent || '0.0' }}%</span>
                                        <span>&nbsp;</span>
                                    </span>
                                </h2>
                                <h3>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[1] && source_dashboard_cards[1].sub_value || 0 }} {{ $t('insight.diners') }}</h3>
                            </div>
                        </a-col>
                        <a-col :span="is_mobile ? 12 : 4">
                            <div class="insight_select_card" @click="changeSelectCard('source', 'google')" :class="{current: source_select_card == 'google'}">
                                <h3>{{ $t('insight.via_google') }}</h3>
                                <h2>
                                    <span>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[2] && source_dashboard_cards[2].value || 0 }}</span>
                                    <span class="sub_text">
                                        <span>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[2] && source_dashboard_cards[2].percent || '0.0' }}%</span>
                                        <span>&nbsp;</span>
                                    </span>
                                </h2>
                                <h3>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[2] && source_dashboard_cards[2].sub_value || 0 }} {{ $t('insight.diners') }}</h3>
                            </div>
                        </a-col>
                        <a-col :span="is_mobile ? 12 : 4">
                            <div class="insight_select_card" @click="changeSelectCard('source', 'ipad')" :class="{current: source_select_card == 'ipad'}">
                                <h3>{{ $t('insight.via_ipad') }}</h3>
                                <h2>
                                    <span>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[3] && source_dashboard_cards[3].value || 0 }}</span>
                                    <span class="sub_text">
                                        <span>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[3] && source_dashboard_cards[3].percent || '0.0' }}%</span>
                                        <span>&nbsp;</span>
                                    </span>
                                </h2>
                                <h3>{{ source_dashboard_cards.length > 0 && source_dashboard_cards[3] && source_dashboard_cards[3].sub_value || 0 }} {{ $t('insight.diners') }}</h3>
                            </div>
                        </a-col>
                    </a-row>
                    <div class="chart" style="margin-top: 20px; height: 300px;" id="source_date_graph_chart"></div>
                </a-card>
            </a-col>
        </a-row>
        <a-row style="margin: 10px 0;">
            <a-col :span="24" style="padding-right: 5px; height: auto;">
                <a-card :title="$t('insight.wait_time')" :bordered="false" style="width: 100%; height: 100%;">
                    <template #extra v-if="!is_mobile">
                        <a-range-picker @change="onDateChange('wait_time')" v-model:value="wait_time_date" :format="dateFormat"></a-range-picker>
                        <a-select v-if="false" v-model:value="wait_time_graph_type" style="width: 120px" @change="handleNumberTypeChange('wait_time', $event)">
                            <a-select-option value="daily">
                                {{ $t('insight.daily') }}
                            </a-select-option>
                            <a-select-option value="week">
                                {{ $t('insight.weekly') }}
                            </a-select-option>
                            <a-select-option value="month">
                                {{ $t('insight.monthly') }}
                            </a-select-option>
                            <a-select-option value="year">
                                {{ $t('insight.yearly') }}
                            </a-select-option>
                        </a-select>
                    </template>
                    <div v-if="is_mobile">
                        <a-range-picker @change="onDateChange('wait_time')" v-model:value="wait_time_date" :format="dateFormat"></a-range-picker>
                        <a-select v-if="false" v-model:value="wait_time_graph_type" style="width: 120px" @change="handleNumberTypeChange('wait_time', $event)">
                            <a-select-option value="daily">
                                {{ $t('insight.daily') }}
                            </a-select-option>
                            <a-select-option value="week">
                                {{ $t('insight.weekly') }}
                            </a-select-option>
                            <a-select-option value="month">
                                {{ $t('insight.monthly') }}
                            </a-select-option>
                            <a-select-option value="year">
                                {{ $t('insight.yearly') }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <a-row :gutter="is_mobile ? 2 : 16" style="margin-top: 5px;">
                        <a-col :span="is_mobile ? 0 : 2">
                        </a-col>
                        <a-col :span="is_mobile ? 12 : 4">
                            <div class="insight_select_card current">
                                <h3>{{ $t('insight.average_wait_time') }}</h3>
                                <h2>{{wait_time_dashboard_cards.length > 0 && wait_time_dashboard_cards[0].value || '0.0'}} {{ $t('insight.mins') }}</h2>
                            </div>
                        </a-col>
                        <a-col :span="is_mobile ? 12 : 4">
                            <div class="insight_select_card current">
                                <h3>{{ $t('insight.max_wait_time') }}</h3>
                                <h2>{{wait_time_dashboard_cards.length > 0 && wait_time_dashboard_cards[1].value || '0.0'}} {{ $t('insight.mins') }}</h2>
                            </div>
                        </a-col>
                    </a-row>
                    <div class="chart" style="height: 300px;" id="wait_time_graph_chart"></div>
                </a-card>
            </a-col>
        </a-row>
        <a-row style="margin: 10px 0;">
            <a-col :span="24" style="padding-right: 5px; height: auto;">
                <a-card :title="$t('insight.party_size')" :bordered="false" style="width: 100%; height: 100%;">
                    <template #extra v-if="!is_mobile">
                        <a-range-picker @change="onDateChange('party_size')" v-model:value="party_size_date" :format="dateFormat"></a-range-picker>
                        <a-select v-if="false" v-model:value="party_size_graph_type" style="width: 120px" @change="handleNumberTypeChange('party_size', $event)">
                            <a-select-option value="daily">
                                {{ $t('insight.daily') }}
                            </a-select-option>
                            <a-select-option value="week">
                                {{ $t('insight.weekly') }}
                            </a-select-option>
                            <a-select-option value="month">
                                {{ $t('insight.monthly') }}
                            </a-select-option>
                            <a-select-option value="year">
                                {{ $t('insight.yearly') }}
                            </a-select-option>
                        </a-select>
                    </template>
                    <div v-if="is_mobile">
                        <a-range-picker @change="onDateChange('party_size')" v-model:value="party_size_date" :format="dateFormat"></a-range-picker>
                        <a-select v-if="false" v-model:value="party_size_graph_type" style="width: 120px" @change="handleNumberTypeChange('party_size', $event)">
                            <a-select-option value="daily">
                                {{ $t('insight.daily') }}
                            </a-select-option>
                            <a-select-option value="week">
                                {{ $t('insight.weekly') }}
                            </a-select-option>
                            <a-select-option value="month">
                                {{ $t('insight.monthly') }}
                            </a-select-option>
                            <a-select-option value="year">
                                {{ $t('insight.yearly') }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <a-row :gutter="16" style="margin-top: 5px;">
                        <a-col :span="is_mobile ? 0 : 2">
                        </a-col>
                        <a-col :span="is_mobile ? 20 : 6">
                            <div class="insight_select_card current">
                                <h3>{{ $t('insight.most_popular_party_type') }}</h3>
                                <h2>{{ party_size_dashboard_cards.length > 0 && party_size_dashboard_cards[0].value || 0}} {{ $t('insight.guests') }}</h2>
                                <h2>{{ party_size_dashboard_cards.length > 0 && party_size_dashboard_cards[0].sub_value || 0}} {{ $t('insight.waitlists') }}, {{ $t('insight.take_up') }} {{ party_size_dashboard_cards.length > 0 && party_size_dashboard_cards[0].percent || '0.0'}}%</h2>
                            </div>
                        </a-col>
                    </a-row>
                    <div class="chart" style="margin-top: 20px; height: 300px;" id="party_size_graph_chart"></div>
                </a-card>
            </a-col>
        </a-row>
        <a-drawer :width="375" :title="$t('waitlist.export_title')" placement="right" :open="show_export_layer" @close="onClose">
            <template #extra>
                <a-button type="primary" @click="doExportDetail" :loading="is_exporting">{{ $t('common.export') }}</a-button>
            </template>
            <a-select
                v-model:value="export_sid"
                :options="[{ value: '', label: $t('common.all_stores') }].concat(store_options)"
                style="width: 100%;"
                @change="handleChangeExportStore"
            >
            </a-select>
            <a-range-picker
                style="width: 100%; margin-top: 10px;"
                v-model:value="export_date_range"
                :format="dateFormat"
                :disabled-date="disabledExportDate"
                @open-change="onExportRangeOpenChange"
                @calendar-change="onExportCalendarChange"
            />
            <a-alert :message="$t('common.tips')" type="success" style="margin-top: 20px;">
                <template #description>
                    <ul>
                        <li>{{ $t('waitlist.export_tip1') }}</li>
                        <li>{{ $t('waitlist.export_tip2') }}</li>
                    </ul>
                </template>
            </a-alert>
        </a-drawer>
    </div>
</template>
<script>
    import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
    import * as echarts from 'echarts';
    import moment from 'moment-timezone';
    import { h } from 'vue';
    import dayjs from 'dayjs';

    import {
        MailOutlined,
        TeamOutlined,
        GlobalOutlined,
        ClockCircleOutlined,
        ScheduleOutlined,
        ContactsOutlined,
        StopOutlined,
    } from '@ant-design/icons-vue';

    export default {
        name: "insight_waitlist",
        components: {
            TeamOutlined,
            ScheduleOutlined,
            ContactsOutlined,
            StopOutlined,
        },
        data() {
            return {
                items: [
                {
                        key: 'summary',
                        icon: () => h(GlobalOutlined),
                        label: this.$t('insight.summary'),
                        title: 'Summary',
                    },
                    {
                        key: 'waitlist',
                        icon: () => h(TeamOutlined),
                        label: this.$t('insight.waitlist'),
                        title: 'Waitlist',
                    },
                    {
                        key: 'reserve',
                        icon: () => h(ClockCircleOutlined),
                        label: this.$t('insight.reserve'),
                        title: 'Reserve',
                    },
                    {
                        key: 'notification',
                        icon: () => h(MailOutlined),
                        label: this.$t('insight.notification'),
                        title: 'Notification',
                    },
                ],
                store_options: [],
                sid: this.$store.state.app.select_sid,
                chain_id: this.$store.state.app.chain_id,
                cluster: this.$store.state.app.cluster,
                timezone: this.$store.state.app.timezone,
                is_mobile: this.$store.state.app.is_mobile,
                current: ['waitlist'],
                waitlistNumberDateGraphChart: null,
                waitlistNumberDayGraphChart: null,
                waitlistWaitTimeGraphChart: null,
                waitlistPartySizeGraphChart: null,
                number_graph_type: 'daily',
                source_graph_type: 'daily',
                wait_time_graph_type: 'daily',
                party_size_graph_type: 'daily',
                dateFormat: 'YYYY-MM-DD',
                moment: moment,

                dashboard_cards: [],
                dashboad_loading: false,

                number_graph_data: null,
                number_graph_day_data: null,
                number_dashboard_cards: [],
                number_graph_loading: false,

                source_graph_data: null,
                source_dashboard_cards: [],
                source_graph_loading: false,

                wait_time_dashboard_cards: [],
                wait_time_graph_data: null,

                party_size_dashboard_cards: [],
                party_size_graph_data: null,

                number_select_card: 'wait_count',
                source_select_card: 'qr',

                number_date: [],
                source_date: [],
                wait_time_date: [],
                party_size_date: [],

                number_sdate: '',
                number_edate: '',
                source_sdate: '',
                source_edate: '',
                wait_time_sdate: '',
                wait_time_edate: '',
                party_size_sdate: '',
                party_size_edate: '',

                mapper: {
                    dashboard: {
                        wait_current: {
                            text: this.$t('insight.currently_waiting'),
                            sub_text: this.$t('insight.diners'),
                            icon: 'team'
                        },
                        wait_total: {
                            text: this.$t('insight.total_waitlist'),
                            sub_text: this.$t('insight.diners'),
                            icon: 'team'
                        },
                        wait_time: {
                            text: this.$t('insight.current_waiting_time'),
                            sub_text: this.$t('insight.mins'),
                            icon: 'schedule'
                        },
                        wait_seated: {
                            text: this.$t('insight.seated_parties'),
                            sub_text: this.$t('insight.diners'),
                            icon: 'contacts'
                        },
                        wait_noshow: {
                            text: this.$t('insight.no_show'),
                            sub_text: this.$t('insight.diners'),
                            icon: 'stop'
                        },
                    }
                },

                show_export_layer: false,
                is_exporting: false,
                export_sid: '',
                export_date_range: [],
                export_range_calendar_dates: [],
                export_sname: 'All'
            }
        },
        async beforeMount() {
            let sdate = dayjs(moment().subtract(30, 'days').format(this.dateFormat), this.dateFormat)
            let edate = dayjs(moment().subtract(0, 'days').format(this.dateFormat), this.dateFormat)

            this.number_date = [sdate, edate];
            this.source_date = [sdate, edate];
            this.wait_time_date = [sdate, edate];
            this.party_size_date = [sdate, edate];

            const exportEnd = dayjs(moment().format(this.dateFormat), this.dateFormat);
            const exportStart = dayjs(moment().subtract(6, 'days').format(this.dateFormat), this.dateFormat);
            this.export_date_range = [exportStart, exportEnd];
        },
        async mounted() {
            this.do_get_store_list();
        },
        watch: {
            current() {
                if (this.current == 'summary') {
                    this.$router.push({
                        path: '/insight/home'
                    });
                } else if (this.current == 'reserve') {
                    this.$router.push({
                        path: '/insight/reserve'
                    });
                } else if (this.current == 'notification') {
                    this.$router.push({
                        path: '/insight/notification'
                    })
                }
            },
        },
        computed: {
            ...mapGetters({
            }),
            ...mapState({
            }),
            numberDateGraphOption() {
                let title = this.$t('insight.total_waitlist');

                if (this.number_select_card == 'seated') {
                    title = this.$t('insight.seated_waitlists');
                } else if (this.number_select_card == 'no_show') {
                    title = this.$t('insight.no_show');
                }

                let option = {
                    title: {
                        show: true,
                        text: title,
                        left: 'center',
                        textStyle: {
                            color: '#333',
                            fontSize: 16,
                        },
                    },
                    xAxis: {
                        data: []
                    },
                    yAxis: {
                    },
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    series: [
                        {
                            type: 'bar',
                            data: [],
                            itemStyle: {
                                color: '#1a73e8'
                            }
                        }
                    ]
                }

                if (this.number_graph_data) {
                    option.xAxis.data = this.number_graph_data.label;
                    option.series[0].data = this.number_graph_data.data;
                }

                return option;
            },
            numberDayGraphOption() {
                let title = this.$t('insight.total_waitlist_days');

                if (this.number_select_card == 'seated') {
                    title = this.$t('insight.seated_waitlists_days');
                } else if (this.number_select_card == 'no_show') {
                    title = this.$t('insight.no_show_days');
                }

                let option = {
                    title: {
                        show: true,
                        text: title,
                        left: 'center',
                        textStyle: {
                            color: '#333',
                            fontSize: 16,
                        },
                    },
                    xAxis: {
                        data: []
                    },
                    yAxis: {},
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    series: [
                        {
                            type: 'bar',
                            data: [],
                            itemStyle: {
                                color: '#1a73e8'
                            }
                        }
                    ]
                }

                if (this.number_graph_day_data) {
                    option.xAxis.data = this.number_graph_day_data.label;
                    option.series[0].data = this.number_graph_day_data.data;
                }

                return option;
            },
            sourceDateGraphOption() {
                let title = this.$t('insight.via_qr_code');

                if (this.source_select_card == 'admin') {
                    title = this.$t('insight.via_tablet');
                } else if (this.source_select_card == 'google') {
                    title = this.$t('insight.via_google');
                } else if (this.source_select_card == 'ipad') {
                    title = this.$t('insight.via_ipad');
                }

                let option = {
                    title: {
                        show: true,
                        text: title,
                        left: 'center',
                        textStyle: {
                            color: '#333',
                            fontSize: 16,
                        },
                    },
                    xAxis: {
                        data: []
                    },
                    yAxis: {},
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    series: [
                        {
                            type: 'bar',
                            data: [],
                            itemStyle: {
                                color: '#1a73e8'
                            }
                        }
                    ]
                }

                if (this.source_graph_data) {
                    option.xAxis.data = this.source_graph_data.label;
                    option.series[0].data = this.source_graph_data.data;
                }

                return option;
            },
            waitTimeGraphOption() {
                let option = {
                    title: {
                        show: false,
                        text: this.$t('insight.wait_time_distribution'),
                        left: 'center',
                        textStyle: {
                            color: '#333',
                            fontSize: 14,
                        },
                    },
                    xAxis: {
                        data: [],
                        nameRotate: 30
                    },
                    yAxis: {},
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    series: [
                        {
                            type: 'bar',
                            data: [],
                            itemStyle: {
                                color: '#1a73e8'
                            }
                        }
                    ]
                }

                if (this.wait_time_graph_data) {
                    option.xAxis.data = this.wait_time_graph_data.label;
                    option.series[0].data = this.wait_time_graph_data.data;
                }

                return option;
            },
            partySizeGraphOption() {
                let option = {
                    title: {
                        show: true,
                        text: this.$t('insight.waitlists_of_diffenrent_party_sizes'),
                        left: 'center',
                        textStyle: {
                            color: '#333',
                            fontSize: 16,
                        },
                    },
                    xAxis: {
                        data: [],
                        name: this.$t('insight.guest_number_of_party'),
                        nameLocation: 'middle',
                        nameTextStyle: {
                            padding: [10, 0, 0, 0]
                        }
                    },
                    yAxis: {
                        name: this.$t('insight.waitlist_amount'),
                        nameLocation: 'middle',
                        nameTextStyle: {
                            padding: [0, 0, 10, 0]
                        }
                    },
                    tooltip: {
                        show: true,
                        trigger: 'item',
                        formatter: '{b} Guests: {c}'
                    },
                    series: [
                        {
                            type: 'bar',
                            data: [],
                            itemStyle: {
                                color: '#1a73e8'
                            }
                        }
                    ]
                }

                if (this.party_size_graph_data) {
                    option.xAxis.data = this.party_size_graph_data.label;
                    option.series[0].data = this.party_size_graph_data.data;
                }

                return option;
            }
        },
        methods: {
            ...mapActions({
                get_waitlist_dashboard: "insight/get_waitlist_dashboard",
                get_waitlist_graph: 'insight/get_waitlist_graph',
                get_waitlist_source: 'insight/get_waitlist_source',
                get_waitlist_time: 'insight/get_waitlist_time',
                get_waitlist_party: 'insight/get_waitlist_party',
                getStoreList: 'app/getStoreList',
                exportWaitlistData: 'waitlist/exportWaitlistData'
            }),
            ...mapMutations({
                setSelectSid: 'app/APP_SET_SELECT_SID'
            }),
            do_show_export_layer() {
                this.show_export_layer = true;
            },
            onClose() {
                this.show_export_layer = false;
            },
            doExportDetail() {
                let that = this;
                const range = this.export_date_range;
                if (!range || !range[0] || !range[1]) {
                    this.$message.warning(this.$t('waitlist.export_select_range'));
                    return;
                }
                const startDate = dayjs(range[0]).format(this.dateFormat);
                const endDate = dayjs(range[1]).format(this.dateFormat);
                const span = dayjs(endDate).diff(dayjs(startDate), 'day');
                if (span > 31) {
                    this.$message.warning(this.$t('waitlist.export_max_days'));
                    return;
                }
                this.is_exporting = true;
                let data = {
                    sid: this.export_sid ? this.export_sid : this.store_options.map(item => item.value).join(','),
                    start_date: startDate,
                    end_date: endDate,
                };

                this.exportWaitlistData(data).then(res => {
                    let uploadExcel = fileName => {
                        const blob = new Blob([res], {
                            type:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                        });
                        const url = URL.createObjectURL(blob);
                        const aLink = document.createElement("a");
                        aLink.setAttribute("download", fileName);
                        aLink.setAttribute("href", url);
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink);
                        URL.revokeObjectURL(url);
                        that.is_exporting = false;
                    };
                    // const fileTag = startDate === endDate ? startDate : `${startDate}_${endDate}`;
                    const fileTag = startDate === endDate ? startDate : `${startDate}`;
                    uploadExcel("w_" + fileTag + '_' + that.export_sname.substring(0, 10) + ".xlsx");
                }).catch(() => {
                    that.is_exporting = false;
                });
            },
            disabledExportDate(current) {
                const d = this.export_range_calendar_dates;
                if (!d || !d[0] || d[1]) {
                    return false;
                }
                return Math.abs(current.diff(d[0], 'day')) > 6;
            },
            onExportRangeOpenChange(open) {
                if (open) {
                    this.export_range_calendar_dates = [];
                }
            },
            onExportCalendarChange(dates) {
                this.export_range_calendar_dates = dates || [];
            },
            handleChangeExportStore(val, data) {
                // alert(this.export_sid);
                this.export_sname = data.label;
            },
            handleChangeStore() {
                this.setSelectSid(this.sid);
                this.request_data();
            },
            async do_get_store_list() {
                let store_list = await this.getStoreList({
                    chain_id: this.chain_id,
                    page: 1,
                    size: 0
                });

                this.store_options = store_list.map(item => {
                    return {
                        value: item.sid,
                        label: item.nick_name,
                    };
                });

                if (!this.sid) {
                    this.setSelectSid(this.store_options[0] && this.store_options[0].value || '');
                    this.sid = this.store_options[0] && this.store_options[0].value || '';
                }

                this.request_data();
            },
            async request_data() {
                this.request_dashboard();
                this.request_number_dashboard();
                this.request_waitlist_number_graph();
                this.request_source_dashboard();
                this.request_waitlist_source_graph();
                this.request_waittime_data();
                this.request_party_size_data();
            },
            async request_dashboard() {
                this.dashboad_loading = true;
                let dashboard_data = await this.get_waitlist_dashboard({
                    sid: this.sid,
                    sdate: '',
                    edate: '',
                    cluster: this.cluster
                });

                if (dashboard_data.code === 100000) {
                    this.dashboard_cards = dashboard_data.data.cards;
                }

                this.dashboad_loading = false;
            },
            async request_number_dashboard() {
                let dashboard_data = await this.get_waitlist_dashboard({
                    sid: this.sid,
                    sdate: dayjs(this.number_date[0]).format(this.dateFormat),
                    edate: dayjs(this.number_date[1]).format(this.dateFormat),
                    cluster: this.cluster
                });

                if (dashboard_data.code === 100000) {
                    this.number_dashboard_cards = dashboard_data.data.cards;
                }
            },
            async request_waitlist_number_graph() {
                this.number_graph_loading = true;
                let number_graph_data = await this.get_waitlist_graph({
                    sid: this.sid,
                    cluster: this.cluster,
                    type: this.number_graph_type,
                    source: this.number_select_card == 'wait_count' ? '' : this.number_select_card,
                    sdate: dayjs(this.number_date[0]).format(this.dateFormat),
                    edate: dayjs(this.number_date[1]).format(this.dateFormat),
                });

                if (number_graph_data.code === 100000) {
                    this.number_graph_data = number_graph_data.data;

                    if (this.number_graph_type == 'daily') {
                        let { data, label_ori } = this.number_graph_data;

                        let new_data = [];
                        let new_label = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                        let new_dict = {};

                        for (let i = 0; i < label_ori.length; i++) {
                            let day = moment.tz(label_ori[i], this.timezone).day();

                            if (!new_dict[new_label[day]]) {
                                new_dict[new_label[day]] = 0;
                            }

                            new_dict[new_label[day]] += data[i];
                        }

                        for (let day in new_dict) {
                            let index = new_label.indexOf(day);

                            new_data[index] = new_dict[day];
                        }

                        this.number_graph_day_data = {
                            data: new_data,
                            label: new_label
                        };
                    } 
                    
                    this.render_number_date_graph();
                    this.render_number_day_graph();
                }

                this.number_graph_loading = false;
            },
            async request_waitlist_source_graph() {
                this.source_graph_loading = true;
                let source_graph_data = await this.get_waitlist_graph({
                    sid: this.sid,
                    cluster: this.cluster,
                    type: this.source_graph_type,
                    source: this.source_select_card,
                    sdate: dayjs(this.source_date[0]).format(this.dateFormat),
                    edate: dayjs(this.source_date[1]).format(this.dateFormat),
                });

                if (source_graph_data.code === 100000) {
                    this.source_graph_data = source_graph_data.data;
                    this.render_source_date_graph();
                }

                this.source_graph_loading = false;
            },
            async request_source_dashboard() {
                let source_dashboard_data = await this.get_waitlist_source({
                    sid: this.sid,
                    sdate: this.source_sdate,
                    edate: this.source_edate,
                    cluster: this.cluster
                });

                if (source_dashboard_data.code === 100000) {
                    this.source_dashboard_cards = source_dashboard_data.data.cards;
                }
            },
            async request_waittime_data() {
                let wait_time_data = await this.get_waitlist_time({
                    sid: this.sid,
                    sdate: dayjs(this.wait_time_date[0]).format(this.dateFormat),
                    edate: dayjs(this.wait_time_date[1]).format(this.dateFormat),
                    cluster: this.cluster
                });

                if (wait_time_data.code === 100000) {
                    this.wait_time_dashboard_cards = wait_time_data.data.cards;
                    this.wait_time_graph_data = {
                        data: wait_time_data.data.data,
                        label: wait_time_data.data.label
                    };

                    this.render_wait_time_graph();
                }
            },
            async request_party_size_data() {
                let party_size_data = await this.get_waitlist_party({
                    sid: this.sid,
                    sdate: dayjs(this.party_size_date[0]).format(this.dateFormat),
                    edate: dayjs(this.party_size_date[1]).format(this.dateFormat),
                    cluster: this.cluster
                });

                if (party_size_data.code === 100000) {
                    this.party_size_dashboard_cards = party_size_data.data.cards;
                    this.party_size_graph_data = {
                        data: party_size_data.data.data,
                        label: party_size_data.data.label
                    };

                    this.render_party_size_graph();
                }
            },
            render_number_date_graph() {
                var chartDom = document.getElementById('number_date_graph_chart');
                this.waitlistNumberDateGraphChart = echarts.init(chartDom);
                
                this.numberDateGraphOption && this.waitlistNumberDateGraphChart.setOption(this.numberDateGraphOption);
            },
            render_number_day_graph() {
                var chartDom = document.getElementById('number_day_graph_chart');
                this.waitlistNumberDateGraphChart = echarts.init(chartDom);
                
                this.numberDayGraphOption && this.waitlistNumberDateGraphChart.setOption(this.numberDayGraphOption);
            },
            render_source_date_graph() {
                var chartDom = document.getElementById('source_date_graph_chart');
                this.waitlistSourceDayGraphChart = echarts.init(chartDom);
                
                this.sourceDateGraphOption && this.waitlistSourceDayGraphChart.setOption(this.sourceDateGraphOption);
            },
            render_wait_time_graph() {
                var chartDom = document.getElementById('wait_time_graph_chart');
                this.waitlistWaitTimeGraphChart = echarts.init(chartDom);
                
                this.waitTimeGraphOption && this.waitlistWaitTimeGraphChart.setOption(this.waitTimeGraphOption);
            },
            render_party_size_graph() {
                var chartDom = document.getElementById('party_size_graph_chart');
                this.waitlistPartySizeGraphChart = echarts.init(chartDom);
                
                this.partySizeGraphOption && this.waitlistPartySizeGraphChart.setOption(this.partySizeGraphOption);
            },
            changeSelectCard(type, value) {
                this[type + '_select_card'] = value;

                if (type == 'number') {
                    this.request_waitlist_number_graph();
                } else if(type == 'source') {
                    this.request_waitlist_source_graph();
                } else if(type == 'wait_time') {
                    console.log('wait_time');
                } else if(type == 'party_size'){
                    console.log('party_size');
                }
            },
            handleNumberTypeChange(type, value) {
                this[type + '_graph_type'] = value;

                if (type == 'number') {
                    this.request_waitlist_number_graph();
                } else if(type == 'source') {
                    this.request_waitlist_source_graph();
                } else if(type == 'wait_time') {
                    console.log('wait_time');
                } else if(type == 'party_size'){
                    console.log('party_size');
                }
            },
            onDateChange(type) {
                if (type == 'number') {
                    this.request_number_dashboard();
                    this.request_waitlist_number_graph();
                } else if(type == 'source') {
                    this.request_source_dashboard();
                    this.request_waitlist_source_graph();
                } else if(type == 'wait_time') {
                    this.request_waittime_data();
                } else if(type == 'party_size'){
                    this.request_party_size_data();
                }
            },
        }
    }
</script>

<style>
    .insight_waiilist {
        max-height: 97vh;
        overflow: auto;
    }
    .insight_waiilist .ant-card-body {
        padding-left: 30px;
    }
    .insight_waiilist p {
        margin-bottom: 2px;
    }
    .insight_select_card {
        border: 1px solid #000;
        border-radius: 5px;
        padding: 5px 10px 5px 10px;
        cursor: pointer;
    }
    .insight_select_card.current {
        border: 1px solid #1a73e8;
    }

    .insight_select_card .sub_text {
        display: inline-block;
        font-size: 12px;
    }

    .insight_select_card .sub_text {
        display: inline-block;
        font-size: 10px;
    }

    .insight_select_card .sub_text span {
        display: block;
    }
</style>